import { createElementVNode as _$ce, className as _$cn, createUnknownComponentVNode as _$cc, superCall as _$su, extend as _$ex, EMPTY_OBJ as _$em, createTextVNode as _$ct } from 'intact-vue-next';
import { Icon } from '../icon';
import { DropdownMenu } from '../dropdown';
import { makePanelStyles } from './styles';
import { DatepickerTime } from '../datepicker/time';
import { _$ } from '../../i18n';
import { Button } from '../button';
import { PanelFlags } from '../datepicker/usePanel';
import { last } from '../datepicker/helpers';
import { ScrollSelect } from '../scrollSelect';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    range = _this$get.range,
    multiple = _this$get.multiple;
  var _this$value = this.value,
    value = _this$value.value.value,
    onConfirm = _this$value.onConfirm,
    onChangeTime = _this$value.onChangeTime,
    onChangeTimeByStep = _this$value.onChangeTimeByStep,
    getTimeValue = _this$value.getTimeValue;
  var lastValue = last(value);
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-time-content"] = true, _classNameObj[k + "-range"] = range, _classNameObj[className] = className, _classNameObj[makePanelStyles(k)] = true, _classNameObj);
  var options = this.step.options.value;
  var _this$disabled = this.disabled,
    isDisabledTime = _this$disabled.isDisabledTime,
    isDisabledTimeByStep = _this$disabled.isDisabledTimeByStep,
    isDisabledConfirm = _this$disabled.isDisabledConfirm;
  var _this$formats = this.formats,
    getValueFormat = _this$formats.getValueFormat,
    getValueString = _this$formats.getValueString;
  var generatePanel = function generatePanel(flag) {
    var timeValue = getTimeValue(flag);
    return _$ce(2, 'div', [range ? _$ce(2, 'div', flag === PanelFlags.Start ? _$('开始时间') : _$('结束时间'), 0, _$cn(k + "-timepicker-title")) : undefined, !options ? _$cc(DatepickerTime, {
      'value': timeValue,
      'ev-$change:value': function ev$changeValue(v) {
        return onChangeTime(v, flag);
      },
      'format': getValueFormat(),
      'flag': flag,
      'isDisabledTime': isDisabledTime
    }) : _$ce(2, 'div', _$cc(ScrollSelect, {
      'value': timeValue ? getValueString(timeValue) : timeValue,
      'ev-$change:value': function ev$changeValue(v) {
        return onChangeTimeByStep(v, flag);
      },
      'data': options,
      'disable': function disable(v) {
        return isDisabledTimeByStep(v, flag);
      }
    }), 2, _$cn(k + "-datepicker-time"))], 0, _$cn(k + "-datepicker-calendar-wrapper"));
  };
  return _$su.call($this, {
    'className': _$cn(k + "-timepicker")
  }, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['base-menu'] = function ($super) {
      return _$cc(DropdownMenu, {
        'className': _$cn(classNameObj),
        'children': _$ce(2, 'div', [_$ce(2, 'div', [generatePanel(PanelFlags.Start), _$ct('\n                    '), range ? generatePanel(PanelFlags.End) : null], 0, _$cn(k + "-datepicker-calendars")), _$ce(2, 'div', _$cc(Button, {
          'type': 'primary',
          'size': 'small',
          'disabled': isDisabledConfirm(),
          'ev-click': onConfirm,
          'children': _$('确定')
        }), 2, _$cn(k + "-datepicker-footer"))], 4, _$cn(k + "-datepicker-wrapper"))
      });
    }, __$blocks['base-menu'] = function ($super, data) {
      var block = $blocks['base-menu'];
      var callBlock = function callBlock() {
        return _$blocks['base-menu'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), (_$blocks['suffix'] = function ($super) {
      return _$cc(Icon, {
        'className': _$cn(k + "-icon-time")
      });
    }, __$blocks['suffix'] = function ($super, data) {
      var block = $blocks['suffix'];
      var callBlock = function callBlock() {
        return _$blocks['suffix'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;